import PageHeader from './PageHeader'
import Sidebar from './Sidebar'
import { useRef, useEffect } from 'react';
import { useUser } from '../hooks/useUser';



export default function Dashbord(prop) {
    const { data: user } = useUser();

    const handleLogout = () => {
        logout();
    };

    //sidebar wrapper ref
    const sidebarRef = useRef(null);
    //Header ref
    const headerRef = useRef(null);
    //Toggle sideba Ref
    const toggleSidebarRef = useRef(null);


    //when toggle sidebar
    function toggleSidebar() {
        sidebarRef.current.classList.toggle('close_icon');
        headerRef.current.classList.toggle('close_icon');

        triggerOverlay()

    }

    //  Custom 'overlay' event trigger equivalent
    function triggerOverlay() {
        const event = new Event('overlay');
        window.dispatchEvent(event);
    }

    //Colse time 
    const handleOverlay = () => {
        const sidebar = sidebarRef.current;
        const isHidden = sidebar?.classList.contains('close_icon');
        const existingOverlay = document.querySelector('.bg-overlay');

        if (window.innerWidth <= 991 && !isHidden && !existingOverlay) {
            const overlay = document.createElement('div');
            overlay.className = 'bg-overlay active';
            document.body.appendChild(overlay);
        }

        if (isHidden && existingOverlay) {
            existingOverlay.remove();
        }

    };


    //responsive sidebar
    const ResponsiveSidebar = () => {
        let windowWidth = window.innerWidth;
        const existingOverlay = document.querySelector('.bg-overlay');
        if (existingOverlay) {
            existingOverlay.remove();
        }

        // handleOverlay();

        if (sidebarRef.current && headerRef.current) {
            //Mobile view
            if (windowWidth <= 991) {
                toggleSidebarRef.current.checked = false;
                sidebarRef.current.classList.add("close_icon");
                headerRef.current.classList.add("close_icon");
            }
            else {

                //defult desktop view
                toggleSidebarRef.current.checked = true;
                sidebarRef.current.classList.remove("close_icon");
                headerRef.current.classList.remove("close_icon");
            }

        }
    }

    useEffect(() => {
   
        //Responsive Sidebar
        ResponsiveSidebar();

        window.addEventListener('resize', ResponsiveSidebar);
        window.addEventListener('overlay', handleOverlay);

        return () => {
            window.removeEventListener('overlay', handleOverlay);
            window.removeEventListener('resize', ResponsiveSidebar);
        };
    }, []);

    return <>

        {/* <!-- tap on top start --> */}
        <div className="tap-top">
            <span className="lnr lnr-chevron-up"></span>
        </div>
        {/* <!-- tap on tap end --> */}

        {/* <!-- page-wrapper Start--> */}
        <div className="page-wrapper compact-wrapper" id="pageWrapper">

            {/* <!-- Page Header Start--> */}
            <PageHeader 
                toggleSidebarRef={toggleSidebarRef} 
                headerRef={headerRef} 
                toggleSidebar={toggleSidebar} />
            {/* <!-- Page Header Ends--> */}

            {/* <!-- Page Body Start--> */}
            <div className="page-body-wrapper">
                {/* <!-- Page Sidebar Start--> */}
                <Sidebar 
                    toggleSidebarRef={toggleSidebarRef}
                    MenuId={prop.MenuId}
                    toggleSidebar={toggleSidebar}
                    sidebarRef={sidebarRef}
                    wrapperType="compact-wrapper" />
                {/* <!-- Page Sidebar Ends--> */}

                {/* <!-- index body start --> */}
                <div className="page-body">
                    {prop.page}
                    {/* <!-- Container-fluid Ends--> */}

                    {/* <!-- footer start--> */}
                    <div className="container-fluid">
                        <footer className="footer"style={{width:"100%"}}>
                            <div className="row">
                                <div className="col-md-12 footer-copyright text-center">
                                  <p className="mb-0">
                                    Copyright © {new Date().getFullYear()} Go Home Express
                                    </p>
                                </div>
                            </div>
                        </footer>
                    </div>
                    {/* <!-- footer End--> */}
                </div>
                {/* <!-- index body end --> */}

            </div>
            {/* <!-- Page Body End --> */}
        </div>
        {/* <!-- page-wrapper End--> */}

        {/* <!-- Modal Start --> */}
        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1">
            <div className="modal-dialog  modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body">
                        <h5 className="modal-title" id="staticBackdropLabel">Logging Out</h5>
                        <p>Are you sure you want to log out?</p>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="button-box">
                            <button type="button" className="btn btn--no" data-bs-dismiss="modal">No</button>
                            <button type="button" onClick={handleLogout}
                                className="btn  btn--yes btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- Modal End --> */}



    </>

}